import KPICards  from '../Components/KPICards';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from 'recharts';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../Components/Table';
import { kpiCardsData, cardTypeData, fundingTypeData, spendRiskData, declineReasons,binLevelData, cardPhysicalVsVirtual} from '../Data/mockData';
import { ChartContainer } from '../Components/ChartContainer';

const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899'];

export default function Cards() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>

      {/* KPI Strip */}
      <div>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827', marginBottom: 16 }}>
          Cards Performance Metrics
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 16 }}>
          {kpiCardsData.map((kpi, index) => (
            <KPICards key={index} {...kpi} />
          ))}
        </div>
      </div>

      {/* Card Distribution */}
      <div>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827', marginBottom: 16 }}>
          Card Distribution
        </h2>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {[{ title: 'Card Type Distribution', data: cardTypeData }].map((item, idx) => (
            <div key={idx} style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb', padding: 24 }}>
              <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 16 }}>
                {item.title}
              </h3>
              <ResponsiveContainer width="100%" height={280}>
                <PieChart>
                  <Pie
                    data={item.data}
                    cx="50%"
                    cy="50%"
                    innerRadius={70}
                    outerRadius={100}
                    paddingAngle={5}
                    dataKey="value"
                    label={(entry) => `${entry.name}: ${entry.value}%`}
                  >
                    {item.data.map((_, index) => (
                      <Cell key={index} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
          ))}
            <ChartContainer title="Virtual vs Physical Cards">
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={cardPhysicalVsVirtual} layout="vertical">
                                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                <XAxis type="number" />
                                <YAxis dataKey="name" type="category" width={120} />
                                <Tooltip />
                                <Bar dataKey="value" fill="#3B82F6" radius={[0, 4, 4, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </ChartContainer>
        </div>
      </div>

      {/* Spend & Risk */}
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb', padding: 24 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827', marginBottom: 16 }}>
          Spend & Risk Analysis
        </h2>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={spendRiskData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="month" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="approved" fill="#10b981" name="Approved" stackId="a" />
            <Bar dataKey="declined" fill="#ef4444" name="Declined" stackId="a" />
          </BarChart>
        </ResponsiveContainer>

        <div style={{ marginTop: 24 }}>
          <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 16 }}>
            Decline Reason Breakdown
          </h3>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {declineReasons.map((item, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 160, fontSize: 14, color: '#4b5563' }}>{item.reason}</div>
                <div style={{ flex: 1, background: '#f3f4f6', height: 24, borderRadius: 999, position: 'relative' }}>
                  <div
                    style={{
                      width: `${(item.count / 450) * 100}%`,
                      background: '#ef4444',
                      height: 24,
                      borderRadius: 999,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      paddingRight: 8,
                      color: '#fff',
                      fontSize: 12,
                      fontWeight: 500,
                    }}
                  >
                    {item.count}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* BIN-Level Table */}
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb' }}>
        <div style={{ padding: 24, borderBottom: '1px solid #e5e7eb' }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827' }}>
            BIN-Level Performance
          </h2>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <Table>
            <TableHeader>
              <TableRow>
                {['BIN', 'Brand', 'Card Type', 'Active Corporates', 'Cards Issued', 'Spend', 'Decline Rate'].map((h) => (
                  <TableHead key={h}>{h}</TableHead>
                ))}
              </TableRow>
            </TableHeader>

            <TableBody>
              {binLevelData.map((row, index) => (
                <TableRow
                  key={index}
                  style={{ cursor: 'pointer' }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = '#f9fafb')}
                  onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                >
                  <TableCell style={{ fontWeight: 500 }}>{row.bin}</TableCell>
                  <TableCell>{row.brand}</TableCell>
                  <TableCell>{row.cardType}</TableCell>
                  <TableCell>{row.activeCorporates}</TableCell>
                  <TableCell>{row.cardsIssued}</TableCell>
                  <TableCell>{row.spend}</TableCell>
                  <TableCell>
                    <span style={{ color: parseFloat(row.declineRate) > 2 ? '#dc2626' : '#16a34a' }}>
                      {row.declineRate}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
